import React from "react";
import { Skeleton } from "@mui/material";
import NoDataPlaceholder from "src/components/no-data-placeholder";
import fetchStatus from "./api/fetch-status";

const ShowWithSkeleton = ({
    children,
    fetchAction,
    variant,
    streamingProperty,
    withKids = true,
    ...props
}) => {
    if (
        !fetchAction ||
        fetchAction.status === fetchStatus.PENDING ||
        fetchAction.status === fetchStatus.REFETCHING
    )
        return (
            <Skeleton variant={variant} {...props}>
                {withKids && children}
            </Skeleton>
        );
    if (
        !fetchAction ||
        (fetchAction.status === fetchStatus.ERROR && streamingProperty === undefined)
    )
        return <NoDataPlaceholder variant="overview-mini" />;
    if (!fetchAction || fetchAction.status === fetchStatus.ERROR) return children;
    if (
        (fetchAction.status === fetchStatus.STREAMING && streamingProperty === undefined) ||
        streamingProperty === null
    )
        return (
            <Skeleton variant={variant} {...props}>
                {withKids && children}
            </Skeleton>
        );
    return children;
};

export default ShowWithSkeleton;
